import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';
import { makePermissionMeta } from '@/shared/helpers/permissions.helpers';

export const DisplayRoutes: RouteRecordRaw[] = [
    {
        path: '',
        redirect: '/display/devices'
    },
    {
        path: 'devices',
        component: wrapRuntimeImport(() => import('./screens/devices.vue')),
        meta: makePermissionMeta('display')
    },
    {
        // BLE Wi-Fi provisioning launcher (deep link + manual "Wi-Fi Setup" popup).
        // Gated on `display:register` — same capability as registering a device.
        path: 'devices/ble-wifi-setup',
        component: wrapRuntimeImport(() => import('./screens/ble-wifi-setup.vue')),
        meta: makePermissionMeta('display', 'register')
    },
    {
        path: 'media',
        component: wrapRuntimeImport(() => import('./screens/media-library.vue')),
        meta: makePermissionMeta('display')
    },
    {
        path: 'playlists',
        component: wrapRuntimeImport(() => import('./screens/playlists.vue')),
        meta: makePermissionMeta('display')
    },
    {
        path: 'groups',
        component: wrapRuntimeImport(() => import('./screens/groups.vue')),
        meta: makePermissionMeta('display')
    }
];
